import { css } from "@emotion/react";

export const layout = css({
  padding: "2rem 0",
});

export const stickyColumn = css({
  position: "sticky",
  top: "6rem",
  alignSelf: "flex-start",
});

/** Allows flex/grid children to shrink so horizontal overflow stays in-column. */
export const mainColumn = css({
  minWidth: 0,
});
